<!--components\Alineacion\QuePasaSi.vue-->
<template>
  <section class="flex flex-col pb-10 pt-10 md:pb-0 md:pt-0">
    <PanelTipoBase1 :titulo1="Data.titulo1" :imagen1="Data.imagen1" :imagenfondo="Data.imagenfondo"
      :textotitulo="Data.textotitulo" :objetoDerecho="Data.objetoDerecho" claseimagenfondo="object-cover"
      orden-texto="md:order-2" orden-imagen="md:order-1" :clasetexto="Data.clasetexto" color-texto="text-black" espaciado="py-0 md:py-0"
      config-imagen="aspect-square object-contain w-[70%] md:w-[70%] transition-transform duration-500 ease-in-out hover:scale-110 cursor-pointer relative"
      config-padding="px-8 md:px-12 pt-16 md:pt-24 pb-12 md:pb-24" contenedor-padre="w-full" clasediv1="p-4 md:p-14"
      contenedor-padre-sub="w-full" contenedor-imagen="flex items-center justify-center p-4 md:p-4" />
  </section>
</template>

<script setup>
import { ref } from 'vue'
import PanelTipoBase1 from '~/components/Paneles/PanelTipoBase1.vue'

const Data = ref({

  imagenfondo: '/img/alineacion/fondo_gris.jpg',
  objetoDerecho: [
    {
      clase_custom: "flex-col md:flex-row pl-[1rem] pr-[1rem] md:pl-[0rem] md:pr-[0rem] gap-[2rem] w-full h-auto justify-start items-center",
      parrafos: ['Además de aumentar el desgaste de los neumáticos, una incorrecta alineación puede afectar a partes mecánicas de la dirección por las vibraciones generadas. Además, también se pueden desajustar otras piezas de la suspensión.'],
      imagen: '/img/alineacion/maestro1.png',
      textotitulo: '¿Qué pasa si no se realiza la alineación en forma periódica?',
      clasetexto: 'text-left text-base text-white',
      clasetitulo: 'text-left font-bold text-xl mb-2 text-white',

    },
  ]
})
</script>